import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startAnalytics } from "./config/analytics";
import { getAppEnvironment } from "./config/app-environment";
import { getAppBuildInfo } from "./config/build-info";
import { startAppWorker } from "./lib/appWorker";
import { startCrashRecorder } from "./lib/CrashLog/recorder";
import { listenForInstallOffer } from "./components/InstallHint";
import "./styles/index.css";

const rootEl = document.getElementById("root");
if (rootEl === null) {
  throw new Error("Missing #root");
}

startCrashRecorder(getAppBuildInfo().gitShaShort);
listenForInstallOffer();
startAppWorker(import.meta.env.VITE_PORTRAIT_BASE);
startAnalytics(getAppEnvironment(), import.meta.env.VITE_CF_ANALYTICS_TOKEN);

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
